import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import CloseIcon from "@material-ui/icons/Close";
import { Confirmed } from "./_Icon";

import "../Styles/_EgiftCardsEmailWindow.css";
import "../Styles/_OrderPopupSimpleWindow.css";

let scrolled_into_view = false;

class EgiftCardsEmailWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailSendingErrorMessage: "",
            emailSent: false
        };
    }

    componentWillMount() {
        this.resetState();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.open === false && this.props.open === true) {
            this.resetState();
        }

        if (this.props.loading === false && prevProps.loading === true && !this.props.err) {
            this.resetErrorMessages();
            this.setState({
                emailSent: true
            });
        } else if (this.props.loading === false && prevProps.loading === true && this.props.err) {
            this.setState({
                emailSendingErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.EGIFTCARDS_SECTION.ERROR_FAILED
            });
        }

        this.scrollWindowIntoView();
    }

    scrollWindowIntoView() {
        var element = document.getElementById("egiftcards-email-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "start",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    }

    postMessageToParentWindow() {
        let data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    handleCancelClick() {
        this.resetErrorMessages();
        this.props.handleCloseEgiftCardsEmailDialog();
    }

    resetState() {
        this.setState({
            emailSent: false
        });
        scrolled_into_view = false;
    }

    handleSubmitClick() {
        this.resetErrorMessages();
        this.props.sendEgiftCardsEmail(this.props.order_id);
    }

    resetErrorMessages() {
        this.setState({
            emailSendingErrorMessage: ""
        });
    }

    handleEnter() {
        this.resetErrorMessages();
    }

    handleInputChange(e) {
        switch (e.target.name) {
            case "additional_info":
                if (e.target.value.length <= 24) {
                    this.setState({
                        additionalInfo: e.target.value
                    });
                }
                break;

            default:
                break;
        }
    }

    getAdditionalTaxInfoPlaceholder() {
        switch (this.props.store) {
            default:
                return "VAT/NIF/IVA 12345";
        }
    }

    render() {
        const {
            ORDER_PAGE: { EGIFTCARDS_SECTION },
            MISC
        } = this.props.currentLanguage;

        return (
            <div className="flex layout vertical">
                <Dialog
                    classes={{
                        paper: "popup-simple-window-dialog-paper"
                    }}
                    scroll="body"
                    className="popup-simple-window-dialog"
                    disableBackdropClick
                    disableEscapeKeyDown
                    aria-labelledby="simple-dialog-title"
                    open={this.props.open}
                    onEnter={this.handleEnter.bind(this)}
                >
                    <div id="popup-simple-window" className="layout vertical popup-simple-window egiftcards-email-window relative">
                        <div className="flex layout horizontal end-justified">
                            <CloseIcon className="layout vertical center-center close-corner-button" onClick={this.handleCancelClick.bind(this)} />
                        </div>
                        <div className="flex layout vertical relative">
                            <div className="layout vertical popup-simple-window-inner">
                                {this.props.loading && (
                                    <div className={`loading-box fit layout vertical center-center`}>
                                        <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                                    </div>
                                )}
                                <div className="layout vertical header">
                                    <p className="layout vertical center-center title">{EGIFTCARDS_SECTION.HEADING}</p>
                                </div>
                                {!this.state.emailSent && (
                                    <React.Fragment>
                                        <div className="layout vertical body">
                                            <p className="">{EGIFTCARDS_SECTION.SUBHEADING}</p>
                                        </div>
                                        <div className="layout vertical footer">
                                            {this.state.emailSendingErrorMessage && <div className="message-box">{this.state.emailSendingErrorMessage}</div>}
                                            <div className="layout vertical buttons-box">
                                                <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                                    <button className="flex custom-button negative" onClick={this.handleCancelClick.bind(this)}>
                                                        <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                                    </button>
                                                    <button
                                                        className={`flex custom-button ${this.props.loading ? "loading" : ""}`}
                                                        style={{ float: "right" }}
                                                        onClick={this.props.loading ? null : this.handleSubmitClick.bind(this)}
                                                    >
                                                        <div className="layout vertical center-center inbutton-text">{MISC.SUBMIT}</div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                                {this.state.emailSent && (
                                    <React.Fragment>
                                        <div className="layout vertical body">
                                            <div className="flex layout horizontal center-center">
                                                <Confirmed fill="#BF0000" />
                                                <p style={{ margin: "0px 10px" }}>{EGIFTCARDS_SECTION.SUCCESS_MESSAGE}</p>
                                            </div>
                                        </div>
                                        <div className="layout vertical footer">
                                            <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                                <button className="flex custom-button negative" onClick={this.handleCancelClick.bind(this)}>
                                                    <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                                </button>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default withRouter(EgiftCardsEmailWindow);



// WEBPACK FOOTER //
// ./src/views/Order/components/_EgiftCardsEmailWindow.jsx